// apps/web/src/components/AvatarModal/AvatarModal.jsx
import Modal from '../Modal/Modal';
import styles from './AvatarModal.module.css';

function AvatarModal({ isOpen, onClose, avatarUrl, displayName, username }) {
    if (!avatarUrl) return null;

    return (
        <Modal isOpen={isOpen} onClose={onClose}>
            <div className={styles.content}>
                <div className={styles.imageWrapper}>
                    <img
                        src={avatarUrl}
                        alt={displayName || username}
                        className={styles.avatarImage}
                    />
                </div>
                <div className={styles.userInfo}>
                    <h3 className={styles.displayName}>{displayName || username}</h3>
                    <p className={styles.username}>@{username}</p>
                </div>
            </div>
        </Modal>
    );
}

export default AvatarModal;